<div class="sticky-top" style="background-color: #FFF; z-index: 1;">
    <div class="row justify-content-between d-flex align-items-center pd-library-header mt-sm-5">
        <div class="col-5">
            <span class="pd-library-title">Your Library</span>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <a role="button" (click)="openUploadArtEvent()" class="float-end me-4 text-nowrap">
                <i class="fas fa-upload" style="color: #1A1A1A"></i>
                <!-- <i class="fas fa-upload pd-library-icon" style="background: #FFF;"></i> -->
                <span class="pd-library-icon-text">
                    Upload art
                </span>
            </a>
        </div>
    </div>
    <div class="row pd-library-body">
        <div class="col">
            <div class="input-group mb-3 pe-4">
                <span class="input-group-text pd-library-icon" id="basic-addon1">
                    <i class="fas fa-search"></i>
                </span>
                <input type="text" class="form-control border-0 pd-library-input" aria-label="Search for assets"
                    aria-describedby="basic-addon1" placeholder="Search for assets..." [formControl]="searchTerm"/>
            </div>
        </div>
    </div>
</div>
<hr class="pd-library-hr">
<div class="row position-relative h-100" [ngClass]="{'library-content-mobile': mobileView}" (drop)="onDrop($event)" (dragover)="dragOverHandler($event)">
    <ng-container *ngIf="designFiles?.length > 0; else noFiles">
        <div *ngFor="let file of filteredFiles; trackBy: trackFiles" [ngClass]="{'border border-white border-4': mobileView, 'border-primary': file.selected && mobileView}"
            class="col-md-6 col-sm-4 mb-4 d-flex justify-content-center align-items-center text-center flex-column position-relative library-file">
            <button type="button" class="btn btn-danger btn-floating position-absolute end-0 right-0 top-0 delete-btn" mdbRipple rippleColor="dark" (click)="onRemoveImage($event, file)" mdbTooltip="Remove Design">
                <i class="fas fa-trash"></i>
            </button>
            <div class="pdl-img-container" [ngClass]="{'transparent-background-pattern': file.hasTransparentBackground}">
                <img loading="lazy" [src]="file.imageUrl" [alt]="'Design Library Image of ' + file.name" class="img-fluid design-image" (click)="onImageSelect(file)"  draggable (dragstart)="onDragStart($event, file)" (dragend)="onDragEnd($event, file)">
            </div>
            <span class="pdl-img-filename"> {{ file.name }} </span>
        </div>
    </ng-container>
</div>
<div class="row">
    <div class="col-12 p-4">
        <button class="btn btn-primary w-100 btn-lg" *ngIf="selectedFiles.length > 0" (click)="addSelectedFiles(selectedFiles)">Add {{selectedFiles.length}} Files</button>
    </div>
</div>
<ng-template #noFiles>
    <div class="cursor-pointer" (click)="openUploadArtEvent()" (drop)="onDrop($event)" (dragover)="dragOverHandler($event)">
        <h4 class="text-center">No design files available</h4>
        <img src="assets/images/select_files_3.svg" width="100%">
        <p class="text-center">You can drop files here or click the button bellow</p>
    </div>
</ng-template>